// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"04b7e216","239":"c47d51ed","453":"22f7b820","455":"2d53b255"}[chunkId] + ".chunk.js";
};